import Vue from "vue";

const charts = {
	props: {
		showFooter: { default: true },
		chartHeight: { default: 400 },
		slug: { default: '' },
		period: { default: '' },
		interpreted: { default: 1 }
	}
}

Vue.component("chart-pie", {
	mixins: [charts],
	props: ['loading', 'chartData', 'chartName', 'seriesName'],
	data() {
		return {
			hasData: true,
			footer: ""
		};
	},
	computed: {
		chartOptions: function() {
			let self = this;
			return {
				styledMode: true,
				chart: { plotBackgroundColor: null, plotBorderWidth: null, plotShadow: false, type: 'pie' },
				legend: { enabled: true, },
				title: { text: null, align: "left", style: { fontWeight: "bold", }, },
				exporting: { buttons: { contextButton: { menuItems: ["downloadPNG"] } } },
				borderWidth: 0,
				credits: {
					enabled: false
				},
				plotOptions: {
					pie: {
						dataLabels: {
							enabled: true,
							format: '<b>{point.name}</b>:<br>{point.percentage:.1f} %',
						}
					}
				},
				series: self.chartData
			};
		},
	},
	mounted() {
		this.$emit("mounted");
	},
	template: `
		<div>
		    <wto-chart :loading.sync="loading"
		                   :has-data="hasData"
		                   :chart-options="chartOptions"
		                   :footer="footer"></wto-chart>
		</div>
	`
});